<script>
  import BaseContentSet from '../BaseContentSet/BaseContentSet.svelte';
  
  let {
    baseContentSet,
    inlineIconsAndText = false,
    noWrapper = false,
    lang,
    dataTestId = 'marketing-no-image',
  } = $props();
</script>

{#if noWrapper}
  <BaseContentSet
    {...baseContentSet}
    lang={lang || 'en'}
    {inlineIconsAndText}
    className="w-full lg:px-16"
    smallerText={true}
  />
{:else}
  <section class="w-full bg-gray-mercury md:mt-12 lg:mt-16">
    <div data-testid={dataTestId} class="max-w-6xl lg:mt-10 lg:mx-auto px-4 py-6 sm:pt-8 md:px-12 lg:pt-12 lg:pb-8">
      <BaseContentSet {...baseContentSet} lang={lang || 'en'} {inlineIconsAndText} className="w-full lg:px-16" />
    </div>
  </section>
{/if}
